import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, BookOpenIcon, BriefcaseIcon, CarIcon, HomeIcon, ShoppingBagIcon, SparklesIcon, UsersIcon, UtensilsCrossedIcon, WrenchIcon } from 'lucide-react';
import { ACCENT_CARD, ACCENT_TILE } from '../../data/marketVisual';
import { cn } from '../../utils/cn';
import type { MarketCategory, MarketCategoryId } from '../../types/market';

/** One icon family, one stroke weight, one size per role. */
export const CATEGORY_ICONS: Record<MarketCategoryId, React.ComponentType<{
  className?: string;
}>> = {
  food: UtensilsCrossedIcon,
  books: BookOpenIcon,
  products: ShoppingBagIcon,
  accommodation: HomeIcon,
  transport: CarIcon,
  services: WrenchIcon,
  gigs: SparklesIcon,
  jobs: BriefcaseIcon,
  roommates: UsersIcon
};
export function CategoryCard({
  category
}: {
  category: MarketCategory;
}) {
  const Icon = CATEGORY_ICONS[category.id];
  return <Link to={category.to} className={cn('group flex h-full flex-col rounded-card border border-line bg-surface px-5 py-5 shadow-[0_1px_2px_rgba(15,23,42,0.04)] transition-[background-color,border-color,box-shadow] duration-150 ease-out hover:border-line-strong hover:shadow-[0_6px_18px_rgba(15,23,42,0.07)] focus-visible:border-brand-700', ACCENT_CARD[category.accent])} data-id="element-2830" data-mp="21hs0952z8b5">
      <span className={cn('flex h-12 w-12 items-center justify-center rounded-full', ACCENT_TILE[category.accent])} data-id="element-2831" data-mp="dqkjswvl9p6z">
        <Icon aria-hidden className="h-6 w-6" data-id="element-2832" data-mp="nlm5tjukib5c" />
      </span>
      <span className="mt-4 text-body-lg font-semibold text-ink" data-id="element-2833" data-mp="11e2d4wui4vc2">{category.label}</span>
      <span className="mt-1.5 text-body-sm leading-6 text-ink-muted" data-id="element-2834" data-mp="11fwtryyqq1ac">{category.blurb}</span>
      <span className="mt-auto flex items-center justify-between gap-2 pt-5" data-id="element-2835" data-mp="whbovm8jmtfk">
        <span className="text-caption text-ink-subtle" data-id="element-2836" data-mp="1bchwuer792bj">{category.countLabel}</span>
        <ArrowRightIcon aria-hidden className="h-4 w-4 text-ink-subtle transition-transform duration-150 ease-out group-hover:translate-x-0.5 group-hover:text-brand-700" data-id="element-2837" data-mp="16egc7pe4kuxy" />
      </span>
    </Link>;
}